// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import DatetimeController from "./datetime_controller"
application.register("datetime", DatetimeController)

import LocationsStepController from "./locations_step_controller"
application.register("locations-step", LocationsStepController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import RevealSecretController from "./reveal_secret_controller"
application.register("reveal-secret", RevealSecretController)

import ResendController from "./resend_controller"
application.register("resend", ResendController)

import StatusIconController from "./status_icon_controller"
application.register("status-icon", StatusIconController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
